import { div, mul, pow } from "./decimal";

export function scaleDecimals(amount: bigint, from: bigint, to: bigint) {
  if (from < to) return mul(amount, pow(10, to - from)).toString();
  if (from > to) return div(amount, pow(10, from - to)).toFixed(0);
  return amount.toString();
}
